import React, { useState } from 'react';
import { Typography, Link, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './App.css';

const AboutUs = () => {
    return (
        <Box className="about-us" sx={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
            <Typography 
                variant="h2" 
                component="h1" 
                gutterBottom
                sx={{ 
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    color: '#2c3e50',
                    textAlign: 'center',
                    mb: 4
                }}
            >
                About Us
            </Typography>

            {/* Research Section */}
            <Box sx={{ mb: 6 }}>
                <Typography 
                    variant="h4" 
                    component="h2"
                    sx={{ 
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        color: '#34495e',
                        mb: 2
                    }}
                >
                    Election Prediction Research
                </Typography>
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                    Led by Dr. Can Dogan from Radford University, this project uses advanced machine learning algorithms to predict election results. It analyzes historical data and voter demographics to provide accurate forecasts.
                </Typography>
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                    [add summary of the research and study]
                </Typography>
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                    Learn more about Dr. Dogan's work and publications on his <Link href="https://webapps.radford.edu/eprofiles/profile/page/cdogan" target="_blank" rel="noopener">faculty page</Link>.
                </Typography>
            </Box>

            {/* Current Team Section */}
            <Box sx={{ mb: 4 }}>
                <Typography 
                    variant="h4" 
                    component="h2"
                    sx={{ 
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        color: '#34495e',
                        mb: 2
                    }}
                >
                    Fall 2024 Development Team
                </Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
                    {['Josh Sapirstein', 'David Soon', 'Bangjing Feng', 'Samuel Spencer', 'Sai Puppala'].map((member) => (
                        <Typography 
                            key={member} 
                            variant="body1" 
                            sx={{ 
                                fontSize: '1.1rem',
                                textAlign: 'center',
                                padding: '1rem',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '8px'
                            }}
                        >
                            {member}
                        </Typography>
                    ))}
                </Box>
            </Box>

            {/* Previous Team Accordion */}
            <Accordion sx={{ mb: 4 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">Spring 2024 Development Team</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
                        {['Pierre Tran', 'Danny Pham', 'Bryan Tran', 'Eunice Hong', 'Danny Chung'].map((member) => (
                            <Typography 
                                key={member} 
                                variant="body1" 
                                sx={{ 
                                    fontSize: '1.1rem',
                                    textAlign: 'center',
                                    padding: '1rem',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '8px'
                                }}
                            >
                                {member}
                            </Typography>
                        ))}
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                This project is part of a capstone for the Computer Science program at Virginia Tech. The team is responsible for the design, development, and deployment of the website.
            </Typography>
        </Box>
    );
};

export default AboutUs;
